const RolePermissions = {
  admin: [
    // Admin Module
    "home.admin.page",
    "home.admin.add",
    "home.admin.update",
    "home.admin.delete",

    // Student Module
    "home.student.page",

    // Blueprint Module
    "home.blueprint.page",
    "home.blueprint.add",
    "home.blueprint.update",
    "home.blueprint.delete",

    // Teacher Module
    "home.teacher.page",
    "home.teacher.add",
    "home.teacher.update",
    "home.teacher.delete",

    // Assessment Module
    "home.student.assessment.delete",

    // Learning Plan Module
    "home.learningPlan.delete",

    // Public Link
    "home.publicLink.page",

    // Activity
    "home.activity.page",

    // Report
    "home.student.weekly-report",

    // Schedule
    "home.schedule.page",
    "home.schedule.report.page",
  ],

  teacher: [
    "home.student.page",
    "home.activity.page",
    "home.student.weekly-report",
    "home.schedule.page",
  ],

  sub_admin: [
    // Teacher Module
    "home.teacher.page",
    "home.teacher.add",

    // Student Module
    "home.student.page",

    // Blueprint Module
    "home.blueprint.page",

    // Assessment Module
    "home.student.assessment.delete",

    // Activity
    "home.activity.page",

    // Report
    "home.student.weekly-report",

    // Schedule
    "home.schedule.page",
    "home.schedule.report.page",
  ],
};

module.exports = RolePermissions;
